import AccessControl from '@modules/auth/AccessControl'
import InputField from '@modules/formFields/InputField'
import PhoneField from '@modules/formFields/PhoneField'
import SelectCompanyField from '@modules/formFields/SelectCompanyField'
import { TextAreaField } from '@modules/formFields/TextAreaField'
import React, { Component } from 'react'
import { Trans, withTranslation } from 'react-i18next'
import { compose } from 'redux'
import { Field, Form, reduxForm, SubmissionError } from 'redux-form/dist/redux-form'
import Consultations from '@services/Consultations'
import { history } from '@services/History'

class DerivationsForm extends Component {
  static defaultProps = {
    initialValues: {},
  }

  submit = (values) => {
    const requestBody = {
      message: values.message,
      company_api_key: values.company && values.company.api_key,
      phone_value: values.phone && values.phone.phone !== '+' ? values.phone.phone : undefined,
      url_value: values.url_value || undefined,
    }

    if (this.props.initialValues.id) {
      return Consultations.externalDerivations
        .update(this.props.initialValues.id, requestBody)
        .then(() => history.push('/derivations'))
        .catch((err) => {
          window.alert(JSON.stringify(err.response.data, null, 2))
          throw new SubmissionError({ ...err.response.data, _error: err.message })
        })
    }

    return Consultations.externalDerivations
      .store(requestBody)
      .then(() => history.push('/derivations'))
      .catch((err) => {
        window.alert(JSON.stringify(err.response.data, null, 2))
        throw new SubmissionError({ ...err.response.data, _error: err.message })
      })
  }

  render() {
    const { handleSubmit, submitting } = this.props
    const { t } = this.props
    return (
      <Form className="md-form" onSubmit={handleSubmit(this.submit)}>
        <Field
          name="message"
          component={TextAreaField}
          label={<Trans>Mensaje</Trans>}
          placeholder={t('Mensaje de la derivación')}
        />
        <Field name="phone" component={PhoneField} label={<Trans>Teléfono</Trans>} placeholder={t('Teléfono')} />

        <Field name="url_value" component={InputField} label={<Trans>Url</Trans>} placeholder={t('Url')} />
        <AccessControl>
          <Field
            name="company"
            component={SelectCompanyField}
            label={<Trans>Compañía</Trans>}
            placeholder={t('Compañía')}
          />
        </AccessControl>
        <button type="submit" className="btn btn-primary" disabled={submitting}>
          <Trans>Guardar</Trans>
        </button>
      </Form>
    )
  }
}

const validate = (values, props) => {
  const { t } = props
  const errors = {}
  if (!values.message) {
    errors.message = t('Campo requerido')
  }

  if (!values.phone && !values.url_value) {
    errors._error = t('Es obligatorio rellenar uno de los campos')
  }

  if (!values.company) {
    errors.company = t('Campo requerido')
  }

  return errors
}

export default compose(withTranslation(), reduxForm({ form: 'derivations', validate }))(DerivationsForm)
